import { SupportedPricingCurrencyType } from '@buggy/shared'
import { useFetchUserStatusQuery } from '@/api/user-api'
import mapCurrency from '@/utils/map-currency'

const useWorkspaceCurrency = (): SupportedPricingCurrencyType => {
  const { data: userStatus } = useFetchUserStatusQuery()

  return mapCurrency(userStatus?.currentWorkspace?.currencyCode)
}

export default useWorkspaceCurrency
